<template>
  <div class="base-detail-page">
    <!-- 1. 顶部Banner（复用公司介绍页Banner） -->
    <section class="hidden md:block relative w-full overflow-hidden">
      <img src="@/assets/about/Rectangle_50.png" alt="北京菌丰生物科技有限公司" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">北京菌丰生物科技有限公司</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          农菌+科技双轮驱动，菌菇产业迎黄金增长期</p>
      </div>
      <div class="absolute inset-0 bg-black/30"></div>
    </section>
    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg6.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[30%] px-6 flex flex-col items-center text-white">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-5 text-center">北京菌丰生物科技有限公司</h2>
        <!-- 描述文字 -->
        <p class="text-[16px] leading-6 text-center opacity-90 mb-10">
          政策 + 市场双轮驱动，蘑菇产业迎黄金增长期
        </p>
      </div>
    </section>
    <!-- 2. 基地详情内容区 -->
    <section class="md:py-16 py-10 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <!-- 天津城市插画 -->
      <div class="text-center mb-12 md:mb-0 relative overflow-hidden md:min-h-[978px] min-h-[300px]">
        <div
          class="md:block hidden absolute inset-0 text-[clamp(5rem,8vw,8rem)] w-full text-center top-[200px] font-bold text-gray-300 leading-none mb-[-2rem]">
          {{ id == 1 ? '天津宝坻' : '重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;庆' }}
        </div>
        <img v-if="id == 1" src="@/assets/about/image_17.png" :alt="id == 1 ? '天津宝坻' : '重庆江津'"
          class="w-full md:h-full object-cover absolute top-0 left-0">
        <img v-else src="@/assets/about/新对话_(1)_1.png" :alt="id == 1 ? '天津宝坻' : '重庆江津'"
          class="w-full md:h-full object-cover absolute top-0 left-0">
        <!-- 基地介绍文字 -->
        <p v-if="id == 1"
          class="md:text-black text-gray-600 md:text-xl text-xs leading-relaxed md:mb-12 absolute md:bottom-[30px] bottom-0 left-0 w-full text-indent text-left">
          依托 198 亩农业资源两期开发多品类栽培，探索「低空经济 + 智慧云仓」融合新模式，打造乡村振兴样板。</p>
        <p v-else
          class="md:text-black text-gray-600 md:text-xl text-xs leading-relaxed md:mb-12 absolute md:bottom-[30px] bottom-0 left-0 w-full text-indent text-left">
          全流程自动化 + 智能环控，年产食用菌超 6 万吨、占据西南食用菌市场近七成份额。</p>
      </div>

      <!-- 地图区域 -->
      <!-- <div class="mb-12 relative overflow-hidden">
        <img src="@/assets/about/image_22.png" alt="天津市宝坻区智慧仿生蘑菇仓基地" class="w-full rounded shadow-sm">
        <div class="absolute top-[30%] w-full text-center z-10">
          <div
            class="bg-[#41B56F] px-4 py-2 mx-auto inline-block rounded text-white text-sm font-bold md:text-2xl  rounded-full">
            {{ id==1? '天津市宝坻区智慧仿生蘑菇仓基地' : '重庆江津市智慧仿生蘑菇仓基地' }}
          </div>
        </div>
      </div> -->

      <div class="w-full mb-12 rounded-lg overflow-hidden">
        <div ref="mapContainer" class="w-full md:h-[350px] h-[200px] rounded-lg"></div>
      </div>

      <!-- 平面图区域 -->
      <div class="mb-12 text-center">
        <img src="@/assets/about/image_21.png" alt="宝坻区方家庄镇菌菇立体仿生培植项目总平面规划方案图"
          class="w-full max-w-2xl mx-auto rounded shadow-sm">
        <p class="md:text-base text-xs text-gray-600 mt-2">
          {{ id == 1 ? '宝坻区方家庄镇菌菇立体仿生培植项目总平面规划方案图' : '重庆江津市智慧仿生蘑菇仓基地总平面规划方案图' }}
        </p>
      </div>

      <!-- 天津城市风光图（3图网格） -->
      <div class="flex gap-4">
        <img :src="id == 1 ? require('@/assets/about/Rectangle_64.png') : require('@/assets/about/Rectangle_64.jpg')"
          alt="天津世纪钟" class="w-[51%] rounded shadow-sm">
        <div class="w-[49%] flex flex-col justify-between">
          <img :src="id == 1 ? require('@/assets/about/Rectangle_67.png') : require('@/assets/about/Rectangle_67.jpg')"
            alt="天津海河" class="w-full h-auto rounded shadow-sm">
          <img :src="id == 1 ? require('@/assets/about/Rectangle_66.png') : require('@/assets/about/Rectangle_66.jpg')"
            alt="天津夜景" class="w-full h-auto rounded shadow-sm">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: "BaseDetailPage",
  data() {
    return {
      id: 1,
      map: null
    };
  },
  mounted() {
    // 页面加载时滚动到顶部
    this.id = this.$route.query.id;
    this.initMap()
  },
  destroyed() {
    if (this.map) this.map.destroy()
  },
  methods: {
    async initMap() {
      const key = 'a120c211fa615d7d8457680c0e92dc4c'        // ⬅ 填你的 key
      const lng = this.id==1?'117.40471785':'106.15908246'         // 经度
      const lat = this.id==1?'39.69594831':'29.13118396'          // 纬度
      const name = this.id == 1 ? '天津宝坻基地' : '重庆江津基地'

      const AMap = await AMapLoader.load({
        key,
        version: '1.4.15',           // 版本
        plugins: []                   // 暂不需要插件
      })

      this.map = new AMap.Map(this.$refs.mapContainer, {
        zoom: 13,
        center: [lng, lat],
        // mapStyle: 'amap://styles/light',
        mapToolBar: false,
        scale: false,
        showBuildingBlock: false,
        features: ['bg', 'road', 'point']
      })

      const marker = new AMap.Marker({
        position: [lng, lat],
        content: `
          <div class="map-label">
            <div class="map-label-name bg-[#41B56F] px-4 py-2 mx-auto inline-block rounded text-white text-sm font-bold md:text-2xl  rounded-full">${name}</div>
          </div>`,
        offset: new AMap.Pixel(-75, -105)
      })
      this.map.add(marker)
    }
  }
}
</script>

<style scoped>
/* 基础过渡效果 */
</style>